<template>
  <div class="menuFrame">
    <div class="container py-3">
      <div
        class="row flex-nowrap mx-2 pt-3 justify-content-between align-items-center"
      >
        <a href="https://www.chanchao.com.tw/en/">
          <div class="d-flex align-items-center">
            <img
              src="../../assets/images/ChanChaoLogo.png"
              class="navLogo mt-2"
            />
            <div class="mx-2 logoText text-dark font-weight-nomal">
              <div>សមាជិក Chan Chao</div>
            </div>
          </div>
        </a>

        <div>
          <select
            class="form-control language-select"
            v-model="selectedLang"
            @change="switchLanguage"
          >
            <option
              v-for="lang in languages"
              :key="lang.value"
              :value="lang.value"
            >
              {{ lang.label }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="container">
      <div class="row formFrame m-1 py-2">
        <div class="rightline col-md-7 my-4 px-4">
          <div class="d-flex align-items-center">
            <img
              src="../../assets/images/PwIcon.png"
              class="mr-2 mb-2"
              style="width: 30px; height: 30px"
              alt=""
            />
            <h4>ពាក្យសម្ងាត់របស់អ្នកមិនត្រឹមត្រូវទេ</h4>
          </div>
          <p class="my-4">
            ភ្លេចលេខសម្ងាត់របស់អ្នក? បញ្ចូលអាសយដ្ឋានអ៊ីមែលរបស់អ្នក
            ហើយយើងនឹងជួយអ្នកកំណត់លេខសម្ងាត់ឡើងវិញ។
          </p>
          <form>
            <div class="form-group h6">
              <label for="forgetpwEmail">អាសយដ្ឋានអ៊ីមែល</label>
              <input
                type="email"
                class="form-control"
                id="forgetpwEmail"
                maxlength="50"
                aria-describedby="emailHelp"
                v-model="email"
                name="email"
                :class="{ 'is-invalid': errors.first('email') }"
                v-validate="'required|email'"
                ref="forgetpwEmail"
              />
              <span
                class="text-danger"
                style="font-size: 10px"
                v-if="errors.first('email')"
                >{{ errors.first("email") }}
              </span>
            </div>

            <div class="form-group h6">
              <label for="forgetpwcode">លេខកូដផ្ទៀងផ្ទាត់</label>
              <div class="d-flex justify-content-center align-items-center">
                <input
                  type="text"
                  class="form-control mr-1"
                  id="forgetpwcode"
                  maxlength="5"
                  v-model="validcode"
                  name="text"
                  :class="{ 'is-invalid': errors.first('text') }"
                  v-validate="'required'"
                  ref="forgetpwcode"
                />
                <img
                  :src="getsrc"
                  class="img-fluid rounded"
                  @click.prevent="resetValidcode"
                  style="width: 120px; height: 35px"
                />
                <a href="#" @click.prevent="resetValidcode">
                  <i class="ml-2 fas fa-redo" style="font-size: 25px"></i>
                </a>
              </div>
              <span
                class="text-danger"
                style="font-size: 10px"
                v-if="errors.first('text')"
                >លេខកូដផ្ទៀងផ្ទាត់ ត្រូវតែបំពេញ</span
              >
            </div>

            <button
              type="submit"
              class="btn btn-block btn-primary mt-4"
              @click.prevent="getResetlink"
            >
              កំណត់ពាក្យសម្ងាត់ឡើងវិញ
            </button>
          </form>

          <div v-if="!Registered">
            <hr />

            <div class="linkFrame">
              <!-- <router-link to="/en/login">ចូល </router-link> -->
              <a href="https://www.chanchao.com.tw/accounts/km/login">ចូល</a>

              <span>
                / អ្នកមិនទាន់ក្លាយជាសមាជិកទេ
                <!-- <router-link to="/en/signup"> ចុះឈ្មោះ</router-link> -->
                <a href="https://www.chanchao.com.tw/accounts/km/signup"
                  >ចុះឈ្មោះ</a
                >
              </span>
            </div>
          </div>
        </div>

        <div class="col-md-5 my-4 px-4 lineBottom">
          <div class="d-flex align-items-center mb-4">
            <i
              class="fas fa-2x fa-question-circle mr-3 mb-2"
              style="color: #ffa042"
            ></i>
            <h4>សំណួរ</h4>
          </div>
          <p style="font-weight: bold">
            Q: មិនបានទទួលអ៊ីមែលលេខកូដផ្ទៀងផ្ទាត់មែនទេ?
          </p>
          <hr />

          <ol class="ml-0 pl-3">
            <li style="font-size: 15px" class="font-weight-bold mb-3">
              សារអ៊ីមែល ឬលេខកូដផ្ទៀងផ្ទាត់អាចស្ថិតនៅក្នុង Junk Folder ?
            </li>
            <p style="font-size: 14px">
              សូមចូលទៅJunk Folderរបស់អ្នក ដើម្បីមើលថាតើសារអ៊ីមែល
              ឬលេខកូដផ្ទៀងផ្ទាត់នៅទីនោះឬអត់។ ប្រសិនបើអ្នករកឃើញវានៅក្នុងJunk
              Folder សូមចងចាំថាត្រូវកំណត់វាជាអ៊ីមែលជា Non-Junk Mail
              ដូច្នេះអ៊ីមែលនឹងត្រូវបានផ្ញើទៅកាន់ប្រអប់សំបុត្ររបស់អ្នក។
            </p>

            <li style="font-size: 15px" class="font-weight-bold mb-3">
              មិនទទួលបានក្នុងការស្វែងរកលេខកូដផ្ទៀងផ្ទាត់បន្ទាប់ពីបញ្ចូលអាសយដ្ឋានអ៊ីមែល?
            </li>
            <p style="font-size: 14px">
              អ្នកអាចរង់ចាំពីរបីនាទីដើម្បីឱ្យប្រព័ន្ធផ្ញើលេខកូដផ្ទៀងផ្ទាត់មកអ្នក។
              ប្រសិនបើអ្នកនៅតែមិនទទួលបាន
              សូមពិនិត្យមើលថាតើអ្នកបានបញ្ចូលអាសយដ្ឋានអ៊ីមែលត្រឹមត្រូវឫអត់
            </p>

            <div class="d-flex mt-3">
              <a href="//www.chanchao.com.tw/en/qa.asp" target="_blank"
                >សំណួរ<i class="fas fa-external-link-alt ml-2"></i
              ></a>
            </div>
          </ol>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import QAen from "@/components/QA_km.vue";
import Footer from "@/components/footer_en.vue";

export default {
  metaInfo: {
    title: "ពាក្យសម្ងាត់របស់អ្នកមិនត្រឹមត្រូវទេ - បណ្តាញពិព័រណ៍ Chan Chao",
  },
  components: {
    QAen,
    Footer,
  },

  data() {
    return {
      getsrc: "",
      email: "",
      validcode: "",
      alertTitle: "",
      alertText: "",
      lastUrl: "",
      CSRF_Token: "",
      Registered: false,
      selectedLang: "km",
      languages: [
        { label: "中文", value: "tw" },
        { label: "English", value: "en" },
        { label: "Tiếng Việt", value: "vn" },
        { label: "ភាសាខ្មែរ", value: "km" },
        { label: "ภาษาไทย", value: "th" },
      ],
    };
  },

  watch: {
    email: function () {
      const vm = this;
      vm.$refs.forgetpwEmail.style.borderColor = "#ced4da";
    },

    validcode: function () {
      const vm = this;
      vm.$refs.forgetpwcode.style.borderColor = "#ced4da";
    },
  },

  methods: {
    switchLanguage() {
      const langCode = this.selectedLang;

      if (langCode === "tw") {
        window.location.href = `https://www.chanchao.com.tw/accounts/forgetPw`;
      } else {
        window.location.href = `https://www.chanchao.com.tw/accounts/${langCode}/forgetPw`;
      }
    },
    getResetlink() {
      const vm = this;
      if (vm.lastUrl.length === 0) {
        vm.lastUrl = "https://www.chanchao.com.tw/en";
      }

      const linkinfo = {
        Email: vm.email,
        Validcode: vm.validcode,
        CSRF: vm.CSRF_Token,
      };

      const url = "https://www.chanchao.com.tw/apiLogin2/forgetPw/km";

      vm.$validator.validate().then((valid) => {
        if (valid) {
          vm.$http.post(url, linkinfo).then(function (response) {
            // // console.log(response)
            if (response.data == "200") {
              vm.alertTitle = "ជោគជ័យ";
              vm.alertText = "អ៊ីមែលកំណត់ពាក្យសម្ងាត់ឡើងវិញត្រូវបានផ្ញើ";
              vm.alertSuccess();
            } else if (response.data == "252") {
              vm.alertText = "គណនីរបស់អ្នកត្រូវបានបិទដំណើរការ";
              vm.alertError();
              vm.$refs.forgetpwEmail.style.borderColor = "red";
            } else if (response.data == "253") {
              vm.alertText = "អ្នកមិនទាន់ក្លាយជាសមាជិកទេ";
              vm.alertError();
              vm.$refs.forgetpwEmail.style.borderColor = "red";
            } else if (response.data == "254") {
              vm.alertText =
                "អាសយដ្ឋានអ៊ីមែលមិនត្រឹមត្រូវ ឬមិនទាន់បានចុះឈ្មោះជាសមាជិក Chan Chao";

              vm.alertError();
              vm.$refs.forgetpwEmail.style.borderColor = "red";
            } else if (response.data == "255") {
              vm.alertText = "សូមបញ្ចូលអាសយដ្ឋានអ៊ីមែលរបស់អ្នក";
              vm.alertError();
              vm.$refs.forgetpwEmail.style.borderColor = "red";
            } else if (response.data == "256") {
              vm.alertText = "លេខកូដផ្ទៀងផ្ទាត់មិនត្រឹមត្រូវ សូមព្យាយាមម្តងទៀត";
              vm.alertError();
              vm.$refs.forgetpwcode.style.borderColor = "red";
            } else {
              vm.alertText =
                "ប្រព័ន្ធកំពុងជាប់រវល់ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ";
              vm.alertError();
            }
          });
        } else {
          vm.alertText = "ការបញ្ចូលមិនពេញលេញ សូមពិនិត្យម្តងទៀត";
          vm.alertError();
        }
      });
    },

    alertError() {
      const vm = this;

      vm.$swal({
        text: vm.alertText,
        icon: "info",
        confirmButtonText: "OK",
        // animation: false,
        allowOutsideClick: true,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      });
    },

    alertSuccess() {
      const vm = this;

      vm.$swal({
        title: vm.alertTitle,
        text: vm.alertText,
        icon: "success",
        confirmButtonText: "OK",
        // animation: false,
        allowOutsideClick: true,
        confirmButtonColor: "#abc6d2",
        width: 300,
        padding: 15,
      }).then(function () {
        document.location.href =
          "https://www.chanchao.com.tw/accounts/km/login";
      });
    },

    resetValidcode() {
      const vm = this;
      vm.$http
        .get("https://www.chanchao.com.tw/apiLogin2/Validcode")
        .then((response) => {
          vm.getsrc = response.data;
        });
    },
  },

  created() {
    const vm = this;

    vm.$http
      .get("https://www.chanchao.com.tw/apiLogin2/Validcode")
      .then((response) => {
        this.getsrc = response.data;
      });

    vm.$http
      .get("https://www.chanchao.com.tw/apiLogin2/CSRF_Token")
      .then((response) => {
        vm.CSRF_Token = response.data;
      });

    //更換英文語系
    vm.$i18n.locale = "km";

    //是否登入狀態

    //取cookie
    // vm.access_token = vm.$cookies.get('as')

    const url = "https://www.chanchao.com.tw/apiLogin2/isAuthenticated";
    const info = null;

    vm.$http.post(url, info).then(function (response) {
      // console.log(response.data)
      if (response.data == 200) {
        vm.Registered = true;
      } else {
        vm.Registered = false;
      }
    });
  },
};
</script>

<style lang="scss">
//Swal setting
.swal2-popup {
  font-size: 13px !important;
}

.swal2-styled.swal2-confirm {
  font-size: 12px;
}

#main-footer {
  bottom: 0;
}

.menuFrame {
  background-color: #f2f2f2;
  min-height: 100%;
}

.navLogo {
  height: 55px;
}

.formFrame {
  background-color: #ffffff;
  margin-top: 40px;
  border-radius: 10px;
  box-shadow: 1px 1px 1px 1px rgba(201, 199, 199, 0.5);
}

.rightline {
  border-right: 1px solid #ccc;
}

.navEnText:hover {
  color: rgb(34, 34, 34) !important;
}

.input-note {
  font-size: 14px;
  color: rgb(190, 67, 67);
}

input::-webkit-input-placeholder {
  /* placeholder*/
  color: #aab2bd;
  font-size: 14px;
}

.linkFrame {
  font-size: 15px;
}

.navText {
  display: flex;
}

.logoText {
  font-size: 20px;
}

@media (max-width: 768px) {
  .rightline {
    border-right: 0px;
  }

  .lineBottom {
    border-top: 0.5px solid rgb(230, 227, 227);
    padding-top: 30px;
  }

  .navEnText {
    display: none;
  }

  .navText {
    display: block;
  }

  .logoText {
    font-size: 16px;
  }

  .navLogo {
    height: 50px;
  }
}

@media (max-width: 992px) {
  .auth-code {
    margin-top: 20px;
    margin-bottom: 20px;
  }
}
</style>
